// Imports for external libraries go here.
import clsx from 'clsx';
import { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
//import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { Icon } from '@marriott/mi-ui-library';
import { DEFAULT_TRACKING_VALUES, getClickTrackValue } from '../../../utils';
import { getIconClass, isLongTextLocale } from '../NavigationUtilityLink/helper';
import { StyledUtilityLink } from './UtilityLink.styles';
import { UtilityLinkProps } from './UtilityLink.types';

export const UtilityLink: FC<UtilityLinkProps> = ({
  restProps,
  defaultIconClass,
  isBrandedVariation,
  isRenderedInsideOverlay,
}) => {
  //const { envVarsObject } = useClientEnvVarsStore();
  //const locale = envVarsObject?.['ACCEPT_LANGUAGE'];
  const shouldOmitUtilityLabels = isBrandedVariation;

  const {
    labelTag: iconClassTag,
    'cq:panelUrl': href,
    openInaNewTab,
    'cq:panelTitle': linkText,
    trackingContentPosition,
  } = restProps;

  const clickTrackValue = getClickTrackValue({
    trackingProperties: {
      trackingContentPosition,
    },
    url: href,
    fallbacks: {
      description: linkText || DEFAULT_TRACKING_VALUES.LABEL_NULLISH,
      position: DEFAULT_TRACKING_VALUES.GLOBAL_NAV,
    },
  });

  //TODO: Keeping the fallback class as globe as of now as currentlty no option from AEM to author icon. Later should be changed.
  const iconClass = getIconClass(iconClassTag || defaultIconClass);
  const target = openInaNewTab === 'true' ? '_blank' : '_self';
  const rel = openInaNewTab === 'true' ? 'noopener noreferrer' : undefined;

  const utilityLabel = !shouldOmitUtilityLabels ? (
    <span
      aria-hidden="true"
      className={clsx('utility-link-text', {
        'd-none d-xl-inline-block': !isRenderedInsideOverlay,
      })}
    >
      {linkText}
    </span>
  ) : null;

  return (
    <StyledUtilityLink isRenderedInsideOverLay={isRenderedInsideOverlay}>
      <Icon
        iconClass={`icon-${iconClass} utility-icon custom_click_track`}
        ariaLabel={linkText}
        iconHref={href}
        target={target}
        rel={rel}
        custom_click_track_value={clickTrackValue}
        enableLinkClsName
        isDecorative={true}
      >
        {href && utilityLabel}
      </Icon>
      {!href && utilityLabel}
    </StyledUtilityLink>
  );
};
